import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M23.9484 21.1667C23.0538 17.133 20.272 14.1557 16.6078 12.8112C18.5563 11.2745 19.6837 8.80145 19.2671 6.0883C18.7891 2.94296 16.1053 0.42188 12.8823 0.0497219C8.42158 -0.454493 4.64712 2.94296 4.64712 7.20478C4.64712 9.47374 5.72554 11.4906 7.39219 12.8112C3.728 14.1557 0.933913 17.133 0.0515682 21.1667C-0.267056 22.6313 0.933905 23.9999 2.46575 23.9999H21.5465C23.0661 24.0119 24.267 22.6433 23.9484 21.1667ZM7.09807 7.20478C7.09807 4.55165 9.29168 2.40273 12 2.40273C14.7083 2.40273 16.9019 4.55165 16.9019 7.20478C16.9019 9.8579 14.7083 12.0068 12 12.0068C9.29168 12.0068 7.09807 9.8459 7.09807 7.20478ZM19.8676 21.6109H4.12016C3.27458 21.6109 2.64958 20.7705 2.96821 20.0022C4.45104 16.4487 7.94366 14.4078 12 14.4078C16.0563 14.4078 19.5489 16.4487 21.0318 20.0022C21.3504 20.7705 20.7254 21.6109 19.8676 21.6109Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
